type CapricornTechSymbolProps = {
  className?: string;
};

export function CapricornTechSymbol({ className }: CapricornTechSymbolProps) {
  return (
    <img src="/capricorn-symbol.svg" alt="Capricorn" className={className} />
  );
}
